import type { BrandSlots } from "@cfg/brand-sdk";

/** Unstyled-but-decent fallbacks for slots a brand does not provide. */
export const DefaultHeader: BrandSlots["Header"] = ({ brand, nav, user, onSignIn, onSignOut }) => (
  <header className="df-header">
    <a href="/" className="df-brand">
      {brand.name}
    </a>
    <nav className="df-nav">
      {nav.map((n) => (
        <a key={n.href} href={n.href} className={n.active ? "is-active" : undefined}>
          {n.label}
        </a>
      ))}
      {user ? (
        <button type="button" className="cfg-btn" onClick={onSignOut}>
          Sign out
        </button>
      ) : (
        <button type="button" className="cfg-btn" onClick={onSignIn}>
          Sign in
        </button>
      )}
    </nav>
  </header>
);

export const DefaultFooter: BrandSlots["Footer"] = ({ brand }) => (
  <footer className="df-footer">
    {brand.tagline || brand.name}
    {brand.fitTags.disclaimer && <small className="df-footer-legal">{brand.fitTags.disclaimer}</small>}
  </footer>
);

export const DefaultCatalogCard: BrandSlots["CatalogCard"] = ({ entry, children }) => (
  <a className="df-card" href={entry.href}>
    <div className="df-card-preview">{children ?? (entry.thumbnailUrl ? <img src={entry.thumbnailUrl} alt="" loading="lazy" /> : null)}</div>
    <h3>{entry.title}</h3>
    {entry.description && <p>{entry.description}</p>}
  </a>
);

export const DefaultEmptyState: BrandSlots["EmptyState"] = ({ title, body, action }) => (
  <div className="df-empty">
    <h2>{title}</h2>
    {body && <p>{body}</p>}
    {action}
  </div>
);

export const DefaultConfiguratorFrame: BrandSlots["ConfiguratorFrame"] = ({ children, aside }) => (
  <div className="df-frame">
    {children}
    {aside}
  </div>
);
